module.exports = __webpack_public_path__ + "public/images/logo.5ee66df405de13cb4d3f4e0e645e3efb.svg";